import { AriaRole } from 'react';
import { styled } from '@zoopla-eng/zds-components/themes';

interface BaseSVGProps {
    fill?: string;
    stroke?: string;
}
interface DecorativeSVGProps extends BaseSVGProps {
    accessibilityType?: 'decorative';
}

interface InformativeSVGProps extends BaseSVGProps {
    accessibilityType?: 'informative';
    accessibilityLabel?: string;
    title?: string;
    desc?: string;
}

type SVGProps = DecorativeSVGProps | InformativeSVGProps;

const Path = styled('path', {
    fill: '$brandPrimary'
});

function ZooplaLogo({ ...props }: SVGProps) {
    const ariaHidden: { informative: 'false'; decorative: 'true' } = {
        informative: 'false',
        decorative: 'true'
    };

    const title = 'title' in props ? props.title : undefined;
    const desc = 'desc' in props ? props.desc : undefined;
    const accessibilityLabel =
        'accessibilityLabel' in props ? props.accessibilityLabel : undefined;
    const role: AriaRole | undefined = props.accessibilityType
        ? {
              informative: 'img',
              decorative: 'presentation'
          }[props.accessibilityType]
        : undefined;

    return (
        <svg
            width="110"
            height="20"
            viewBox="0 0 110 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={
                props.accessibilityType
                    ? ariaHidden[props.accessibilityType]
                    : undefined
            }
            aria-label={accessibilityLabel}
            role={role}
        >
            <g xmlns="http://www.w3.org/2000/svg" clipPath="url(#a)">
                <Path d="M100.02 16.06c-3.27 0-5.82-2.28-5.82-6.06 0-3.68 2.41-6.09 5.82-6.09 3.6 0 5.98 2.63 5.98 6.12a5.76 5.76 0 0 1-5.98 6.03ZM78.7 19.44h11.29v-3.57h-7.3V.56h-4v18.88ZM68.29 12.5a4.18 4.18 0 0 1-4.35-4.37 4.22 4.22 0 0 1 4.35-4.37c2.55 0 4.42 1.72 4.42 4.37 0 2.66-1.87 4.37-4.42 4.37Zm-8.34 6.95h4v-6.76a5.94 5.94 0 0 0 5.5 3.36c3.93 0 7.23-3.25 7.23-7.92S73.38.18 69.44.18c-2.41 0-4.4 1.2-5.5 3.36v-3h-4v18.9Zm-11.78-3.32c-3.33 0-5.93-2.4-5.93-6.07 0-3.7 2.6-6.2 5.93-6.2 3.33 0 5.87 2.5 5.87 6.2 0 3.68-2.54 6.07-5.87 6.07Zm.03 3.7c5.71 0 9.87-3.97 9.87-9.77 0-5.79-4.16-9.87-9.87-9.87-5.72 0-9.96 4.08-9.96 9.87 0 5.8 4.24 9.77 9.96 9.77Zm-21.44-3.7c-3.32 0-5.9-2.4-5.9-6.07 0-3.7 2.58-6.2 5.9-6.2 3.33 0 5.9 2.5 5.9 6.2 0 3.68-2.57 6.07-5.9 6.07Zm.03 3.7c5.71 0 9.87-3.97 9.87-9.77 0-5.79-4.16-9.87-9.87-9.87-5.71 0-9.95 4.08-9.95 9.87 0 5.8 4.24 9.77 9.95 9.77ZM.48 19.44h15.5v-3.57H4.77c.1-2.81 2.12-3.56 4.4-4.34 3.13-1.07 6.76-2.44 6.76-9.55V.56H.53V4.1h11.16c-.1 2.65-2.07 3.35-4.3 4.1C4.24 9.28.49 10.64.49 18v1.44Zm98.82.38a7.53 7.53 0 0 0 6.7-3.65v3.27h4V.56h-4V3.8A7.51 7.51 0 0 0 99.3.18c-5 0-9.12 4.1-9.12 9.82 0 5.72 4.13 9.82 9.12 9.82Z" />
            </g>
            {title && <title>{title}</title>}
            {desc && <desc>{desc}</desc>}
        </svg>
    );
}

export default ZooplaLogo;
